<template>
  <div>
    <div>

      <v-row justify="center">
        <v-dialog v-model="dialog" width="430px">
          <v-card>
            <v-card-text>
              <div class="text-center">
                <br>
                <br>
                <label style="font-family: Helvetica; font-style: normal; font-weight: 400; font-size: 18px; line-height: 140%; letter-spacing: 0.02em;
                  color: black; flex: none; order: 1; flex-grow: 0;">Estas son las coberturas y
                  protecciones del</label>
                <br>
                <br>
                <label style="font-family: Helvetica; font-style: normal; font-weight: 400; font-size: 18px; line-height: 140%; letter-spacing: 0.02em;
                  color: black; flex: none; order: 1; flex-grow: 0;">Plan <label style="font-family: Helvetica; font-style: normal; font-weight: 600; 
                  font-size: 20px; line-height: 140%; letter-spacing: 0.02em;
                  color: #2D387C; flex: none; order: 1; flex-grow: 0; text-transform: uppercase;">{{ info[0][indexInfo]
                    }}</label> de
                  Mascotas</label>
                <br>
                <br>
                <label class="text-center encabezado">Libre elección y sin deducible</label>
                <br>
                <br>
                <label class="texto">Puedes llevar a tu mascota a la
                  clínica veterinaria <label class="textoAzul">que tú quieras</label>, sin restricciones. Además, todas
                  nuestras coberturas son <label class="textoAzul">sin
                    deducible</label>.</label>
                <br>
                <br>
                <label class="text-center encabezado">Urgencias Médicas</label>
                <br>
                <br>
                <label class="texto">Te devolveremos hasta el <label class="textoAzul">{{ info[1][indexInfo] }}</label>
                  de
                  tus
                  gastos frente a urgencias veterinarias sin deducibles en cualquier clínica, con un <label
                    class="textoAzul">Tope
                    UF {{ info[2][indexInfo] }}</label>.</label>
                <br>
                <br>
                <label class="texto">Puedes usarlo a los <label class="textoAzul">15 días</label> de
                  contratación y hasta <label class="textoAzul">{{ info[3][indexInfo] }} veces al año</label>.</label>
                <br>
                <br>
                <label class="text-center encabezado">Consultas Médicas</label>
                <br>
                <br>
                <label class="texto">Reembolsamos las consultas médicas y
                  controles de tu mascota con el Veterinario que tú quieras, con un <label class="textoAzul">Tope de UF
                    {{ info[4][indexInfo] }}</label>.</label>
                <br>
                <br>
                <label class="texto">Puedes usarlo a los <label class="textoAzul">15 días</label> de
                  contratación y <label v-if="info[5][indexInfo] == 1" class="textoAzul">{{ info[5][indexInfo] }} vez al
                    año</label> <label v-if="info[5][indexInfo] != 1" class="textoAzul">{{ info[5][indexInfo] }} veces
                    al
                    año</label>.</label>
                <br>
                <br>

                <label class="text-center encabezado">Medicamentos</label>
                  <br>
                  <br>
                  <label class="texto">¿Le recetaron remedios a tu mascota?
                    Te damos hasta <label class="textoAzul">$10.000 al mes</label> en reembolsos para medicamentos
                    veterinarios con receta.</label>
                  <br>
                  <br>
                  <label class="texto">Puedes usarlo a los <label class="textoAzul">30 días</label> de
                    contratación y <label class="textoAzul">1 vez al mes</label>.</label>
                  <br>
                  <br>

                <div v-if="indexInfo != 2">

                  
                  <label class="text-center encabezado">Vacuna Obligatoria</label>
                  <br>
                  <br>
                  <label class="texto">Te reembolsamos <label class="textoAzul">UF 0,5</label> en el pago de
                    la vacuna de tu mascota en cualquier clínica.</label>
                  <br>
                  <br>
                  <label class="texto">Puedes usarlo a los <label class="textoAzul">30 días</label> de
                    contratación y <label class="textoAzul">1 vez al año</label>.</label>
                  <br>
                  <br>

                </div>

                <div v-if="indexInfo == 2">

                  <label class="text-center encabezado">Vacuna Antirrábica</label>
                  
                  <br>
                  <br>
                  <label class="texto">Te reembolsamos <label class="textoAzul">UF 0,5</label> en el pago de
                    la vacuna de tu mascota en cualquier clínica.</label>
                  <br>
                  <br>
                  <label class="texto">Puedes usarlo a los <label class="textoAzul">30 días</label> de
                    contratación y <label class="textoAzul">1 vez al año</label>.</label>
                  <br>
                  <br>

                </div>

                <label class="text-center encabezado">Responsabilidad Civil</label>
                <br>
                <br>
                <label class="texto">Tu mascota se portó mal y mordió o
                  hizo algún daño a otra persona, te ayudamos en caso de demanda con <label class="textoAzul">UF {{
                    info[8][indexInfo] }}
                  </label> si tienes que pagar por los
                  daños.</label>
                <br>
                <br>
                <label class="texto">Puedes usarlo desde el  <label class="textoAzul">día uno</label> de
                  contratación y <label class="textoAzul">1 vez al año</label>.</label>
                <br>
                <br>
                <label class="text-center encabezado">Telemedicina Veterinaria</label>
                <br>
                <br>
                <label class="texto">¿Tienes dudas de salud de tu mascota?
                  Deja que nuestros expertos te ayuden llamando sin costo a la hora que necesites.</label>
                <br>
                <br>
                <label class="texto">Puedes usarlo a los <label class="textoAzul">{{ info[9][indexInfo] }} días</label>
                  de
                  contratación y hasta <label class="textoAzul">{{ info[6][indexInfo] }} veces al año</label>.</label>
                <br>
                <br>

                <div v-if="indexInfo != 3">

                  <label class="text-center encabezado">Asesoría Legal Teléfonica</label>
                  <br>
                  <br>
                  <label class="texto">¿Necesitas ayuda con temas legales
                    por algo de tu mascota? Deja que nuestros expertos te ayuden llamando sin costo a la hora que
                    necesites.</label>
                  <br>
                  <br>
                  <label class="texto">Puedes usarlo a los <label class="textoAzul">15 días</label> de
                    contratación y hasta <label class="textoAzul">{{ info[7][indexInfo] }} veces al año</label>.
                  </label>

                </div>

                <div v-if="indexInfo == 3">

                  <label class="text-center encabezado">Cremación</label>
                  <br>
                  <br>
                  <label class="texto">Si a consecuencia de un accidente o por vejez tu mascota fallece, te apoyamos con
                    <label class="textoAzul">UF 3.</label></label>
                  <br>
                  <br>
                  <label class="texto">Puedes usarlo a los <label class="textoAzul"> 60 días</label>
                    de
                    contratación.</label>

                </div>

                <br>

              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn style="box-sizing: border-box; padding: 12px 24px; gap: 10px; background: #FFB600; border: 2px solid #FFB600;
                    border-radius: 8px; margin-top: -6%; font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 14px; line-height: 17px;
                    letter-spacing: 0.02em; color: white; flex: none; order: 0; flex-grow: 0; margin:auto;"
                elevation="0" text @click="dialog = false">
                Aceptar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

    </div>


    <!-- ------------------------------------------------------------------------------------------------------------- -->



    <v-row class="row-tittle">
      <label class="text-center" style="color: white; font-size:18px; margin-right: 10px; margin-left: -40px">{{
        planData.name }}</label>

      <label class="text-center" style="color: white; font-size:18px">{{ formatPrice(planData.priceCLP) }}</label>

      <label class="text-center" style="font-family: Helvetica; font-style: normal; font-weight: 400; font-size: 12px; line-height: 15px;
      color: white; flex: none; order: 1; flex-grow: 0; margin-top: 7px">&nbsp;&nbsp;(UF {{
        (planData.values[0].price).toFixed(2)
      }}
        mensual)</label>
    </v-row>


    <div class="plan2">

      <v-col class="text-center">
          <br>
          <ul class="lista-check">

            
              <div class="text-container">
                <img src="../assets/images/ticket-figma.png" alt="icono" class="icono" >
                <v-row style="justify-contet:center; text-align: center; display:flex;">
                   <span class="main-text">{{ planData.coverage[1].amount }}% Urgencias hasta {{ planData.coverage[1].uf }}
                     UF.</span>
                   <span class="sub-text">{{ planData.coverage[1].eventos }} </span>
                </v-row>  
              </div>
           
              <br>
           
              <div class="text-container">
                <img src="../assets/images/ticket-figma.png" alt="icono" class="icono">
                <v-row style="justify-contet:center; text-align: center; display:flex;">
                  
                  <span class="main-text"> Consulta Médica hasta {{ planData.coverage[5].uf }} UF.</span>
                  <span class="sub-text">{{ planData.coverage[5].eventos }} </span>
                </v-row>
              </div>
            

            <br>
              
              <div class="text-container">
                <img src="../assets/images/ticket-figma.png" alt="icono" class="icono">
                <v-row style="justify-contet:center; text-align: center; display:flex;">
                  <span class="main-text">UF {{ planData.coverage[2].uf }} Responsabilidad Civil.</span>
                  <span class="sub-text">{{ planData.coverage[2].eventos }} </span>
                </v-row> 
              </div>
           

          </ul>

        <div class="plan-info">
          <u style="padding: 12px 24px; gap: 10px; color:#2D387C; border-radius: 8px;  
        flex: none; order: 7; flex-grow: 0; width: 250px;" elevation="0" @click="Info(index)"> MÁS INFORMACIÓN </u>
        </div>

      </v-col>

    </div>

    <br>

    
  </div>
</template>

<script>
import LibreEleccion from "../assets/images/libreeleccion.png"
import ShieldService from "../services/shield.service";

import CryptoJS from 'crypto-js'

import Vue from "vue";
import { VueReCaptcha } from 'vue-recaptcha-v3'
const { VUE_APP_RECAPTCHA3_SITE_KEY } = process.env;
Vue.use(VueReCaptcha, { siteKey: VUE_APP_RECAPTCHA3_SITE_KEY })

export default {
  name: "Plan",
  props: ["planData", "planSenior", "index", "tipoPlan", "userData", "planDataAux", "servicesData"],
  data: () => ({
    secretKey: process.env.VUE_APP_CRYPT,
    formatter: new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
    }),
    LibreEleccion,
    info: [['Plan S', 'Plan M', 'Plan L', 'Plan Senior'], ['40%', '60%', '80%', '50%'], ['50', '100', '250', '20'], ['2', '2', '3', '3'], ['1', '2', '3', '3'], ['1', '1', '1', '4'], ['3', '3', '3', '6'], ['2', '2', '2', '4'], ['5', '10', '15', '8'], ['15', '15', '15', '30']],
    indexInfo: '0',
    dialog: false,
    activeCampaingUse: process.env.VUE_APP_ACTIVE_CAMPAIGN ? process.env.VUE_APP_ACTIVE_CAMPAIGN : 'FALSE',
  }),
  methods: {
    Info(index) {
      this.indexInfo = index
      if (this.planData.name == 'Plan Senior') {
        this.indexInfo = 3
      } else {
        this.indexInfo = index
      }
      this.dialog = true
    },
    formatPrice(number) {
      return this.formatter.format(number);
    },
    ufchange(uf) {
      let nn = uf.toString();
      let new_uf = nn.replace('.', ',')
      return new_uf;
    },
    async validate() {

      // reCaptcha v3 token
      await this.$recaptchaLoaded();
      const tokenStep = await this.$recaptcha('captchaToken');

      this.planDataAux.plan = this.planData;

      const planDataLocal = JSON.stringify(this.planDataAux);
      const encryptedPlanDataLocal = CryptoJS.AES.encrypt(planDataLocal, this.secretKey).toString();
      localStorage.setItem('planData', encryptedPlanDataLocal);

      try {

        await ShieldService.newCreateStep(null, null, this.planDataAux, this.servicesData, 'Planes', tokenStep);

      } catch (error) {
        console.log("Cart Fail");
      }

      if (this.userData.email && this.activeCampaingUse == 'TRUE') {
        const activeCampaingRes = await ShieldService.getContactActiveCampain(this.userData.email);

        this.servicesData.contactID = activeCampaingRes.data.data.contacts[0].id;

        await ShieldService.updateContactActiveCampain(null, this.planDataAux, null, this.servicesData, 1);

        const servicesDataLocal = JSON.stringify(this.servicesData);
        const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
        localStorage.setItem('servicesData', encryptedServicesDataLocal);

      }

      this.$router.push({ path: '/mt/mascotas' })
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>

.info-row {
  display: flex;
  align-items: center;
  // margin-right: 10px;
}

.icono {
  margin-right: 10px;
  width: 20px;
  height: 20px;
}

.text-container {
  display: flex;
  flex-direction: wrap;
  align-content: center;
  margin-left: 10px;

}

.main-text {
  font-family: Helvetica, sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 140%;
  color: #1a2b70;
}

.sub-text {
  font-family: Helvetica, sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  margin-left: 10px;
}

.texto {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: rgba(0, 0, 0, 0.5);
  flex: none;
  order: 1;
  flex-grow: 0;
}

.textoAzul {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400px;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: #2D387C;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.encabezado {
  color: #2D387C;
  font-size: 18px;
  font-weight: 600;
}

.container-details {
  width: 100%;
  // margin-top: -120px;
  padding-left: 13%;
}

.plan-info {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.plan {
  background: linear-gradient(#4F74E3, #2D387C);
  //background-image: url("~@/assets/images/fondoPlanRecomendaado2.png");
  background-position: center;
  background-size: cover;
  width: 350px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0.5rem;
  align-items: center;
  padding: 0.75rem;
  height: 680px;
  border-radius: 10px;
  position: absolute;
}

.row-tittle {
  background: linear-gradient(to bottom, #2A3881, #2A3FAD);
  background-position: center;
  justify-content: center;
  align-items: center;
  margin-right: 11px;
  margin-bottom: -55px;
  border-radius: 10px 10px 0 0;
  height: 50px;
}

.plan2 {
  background-color: #F1F2FF;
  //background-image: url("~@/assets/images/planNormal.png");
  background-position: center;
  background-size: cover;
  width: 350px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0.75rem;
  margin-top: 15%;
  height: 200px;
  margin-right: 10px;
  border-radius: 0px 0px 10px 10px;
}

.texto-recomendado {
  background-color: white;
  color: #2E3A8C;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
  display: inline-block;
}

.precio {
  background: #2E3A8C;
}

.lista-check {
  list-style: none;
  padding: 0;
  align-items: auto;
  justify-items: auto;
  left: 0;
}

.lista-check li {
  margin-bottom: 10px;
  /* Ajusta el espacio entre elementos */

}

</style>